import RecordRTC from 'recordrtc';
import { getResolutionValue, IResolution, Recorder, RESOLUTION } from '@domain/constant/webcamTypes';

const customRTC = require('@lib/recordRTC/RecordRTC');

export default class WebcamUtil {
  static async getUserMediaPromise(mediaStreamConstraints: MediaStreamConstraints): Promise<MediaStream> {
    if (!navigator.mediaDevices.getUserMedia) {
      throw new Error('Your browser does not support getUserMedia API');
    }

    return await navigator.mediaDevices.getUserMedia(mediaStreamConstraints);
  }

  static async getRecorderPromise(
    options: RecordRTC.Options,
    mediaStreamConstraints: MediaStreamConstraints,
  ): Promise<Recorder> {
    const stream = await this.getUserMediaPromise(mediaStreamConstraints);

    const { RecordRTCPromisesHandler } = customRTC.CustomRecordRTC();

    const { startRecording, stopRecording, getBlob, getDataURL, destroy } = new RecordRTCPromisesHandler(stream, {
      ...options,
    });

    return { stream, startRecording, stopRecording, getBlob, getDataURL, destroy };
  }

  static downloadBlobAsFile = (filename: string, blob: Blob) => {
    //@ts-ignore IE 분기처리
    if (window.navigator.msSaveOrOpenBlob !== undefined) {
      //@ts-ignore IE 분기처리
      window.navigator.msSaveBlob(blob, filename);
      return;
    }

    const el = window.document.createElement('a');
    el.style.display = 'none';
    el.href = window.URL.createObjectURL(blob);
    el.download = filename;
    document.body.appendChild(el);
    el.click();
    document.body.removeChild(el);
  };

  static captureImage = (
    videoElement: HTMLVideoElement,
    option: IResolution = getResolutionValue(RESOLUTION.VGA),
    blobCallback: (blob: Blob | null) => void,
  ) => {
    const canvasEl = document.createElement('canvas');
    canvasEl.width = option.width;
    canvasEl.height = option.height;

    const context = canvasEl.getContext('2d');

    if (context) {
      context.translate(canvasEl.width, 0);
      context.scale(-1, 1);
      context.drawImage(videoElement, 0, 0, option.width, option.height);

      if (blobCallback) canvasEl.toBlob(blobCallback);

      return canvasEl.toDataURL();
    }
  };
  static getBlobVideoLength = (blob: Blob): Promise<number> => {
    return new Promise<number>((resolve) => {
      const videoElement = document.createElement('video');
      if (blob !== null) {
        videoElement.src = URL.createObjectURL(blob);
      }
      if (videoElement) {
        const handleLoaded = () => {
          // Chrome bug: https://bugs.chromium.org/p/chromium/issues/detail?id=642012
          if (videoElement.duration === Infinity) {
            videoElement.currentTime = Number.MAX_SAFE_INTEGER;
            videoElement.ontimeupdate = () => {
              videoElement.ontimeupdate = null;
              videoElement.currentTime = 0;
              resolve(videoElement.duration);
              videoElement.removeEventListener('loadedmetadata', handleLoaded);
            };
          }
          // Normal behavior
          else {
            videoElement.removeEventListener('loadedmetadata', handleLoaded);
            resolve(videoElement.duration);
          }
        };
        videoElement.addEventListener('loadedmetadata', handleLoaded);
      }
    });
  };
}
